import { render, staticRenderFns } from "./EDrawerHistoricoAtendimentos.vue?vue&type=template&id=0617930c&scoped=true"
import script from "./EDrawerHistoricoAtendimentos.vue?vue&type=script&lang=js"
export * from "./EDrawerHistoricoAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617930c",
  null
  
)

export default component.exports